export const isAuthErrorCode = (code) =>
  code === "permission-denied" || code === "unauthenticated";
